import { store } from '@utils/configStore'
import { userStoreManagementReducer } from './slice'

export const injectUserStoreManagement = () => store.injectReducer('userStoreManagement', userStoreManagementReducer)
